import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import s from "./Accessor.js";
import r from "./Handles.js";
import { property as t } from "./accessorSupport/decorators/property.js";
import { subclass as o } from "./accessorSupport/decorators/subclass.js";
import { WatchUpdatingTracking as n } from "../views/support/WatchUpdatingTracking.js";

var a = function a(s) {
  var a = /*#__PURE__*/function (_s) {
    _inherits(a, _s);

    var _super = _createSuper(a);

    function a() {
      _classCallCheck(this, a);

      return _super.apply(this, arguments);
    }

    _createClass(a, [{
      key: "destroy",
      value: function destroy() {
        var e, s;
        this.destroyed || (null == (e = this._get("handles")) || e.destroy(), null == (s = this._get("updatingHandles")) || s.destroy());
      }
    }, {
      key: "handles",
      get: function get() {
        return this._get("handles") || new r();
      }
    }, {
      key: "updatingHandles",
      get: function get() {
        return this._get("updatingHandles") || new n();
      }
    }]);

    return a;
  }(s);

  return e([t({
    readOnly: !0
  })], a.prototype, "handles", null), e([t({
    readOnly: !0
  })], a.prototype, "updatingHandles", null), a = e([o("esri.core.HandleOwner")], a), a;
};

var d = /*#__PURE__*/function (_a) {
  _inherits(d, _a);

  var _super2 = _createSuper(d);

  function d() {
    _classCallCheck(this, d);

    return _super2.apply(this, arguments);
  }

  return d;
}(a(s));

d = e([o("esri.core.HandleOwner")], d);
export { d as HandleOwner, a as HandleOwnerMixin };